import React, { useContext, useEffect, useRef, useState } from "react";
import { Colorcontext } from "../../Component/Colorcontext/ColorContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import bannerloginimage from "../../Images/bannerloginimage.png";
import "./Style.css"
import { reactLocalStorage } from "reactjs-localstorage";
import SkeletonSignupForm from "../../View/SearchHome/skeletons/SkeletonSignupForm";

const CardMemberRegistrationProfileName = () => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(location.state?.formData);
  const [formError, setFormError] = useState({
    userNameError: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const newLocal = "check-profile-link";
  const [userName, setUserName] = useState("")

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  useEffect(() => {
    setFormError({ ...formError, userNameError: true })
  }, [userName])

  const checkProfileName = async (val) => {
    const link = process.env.REACT_APP_APPLICATION_URL + '/Memberinvitation/' + val
    try {
      const res = await HttpClient.requestData(
        newLocal,
        "POST",
        { userLink: link }
      );

      if (res?.status) {
        setFormError({ ...formError, userNameError: false })
        setFormData({ ...formData, userLink: link, userName: val })
      }
    } catch (error) {
      console.log("Profile name availability:", error);
    }
  }

  const handleCreate = async (e) => {
    e.preventDefault()
    try {
      setShowLoader(true);
      const res = await HttpClient.requestData("add-non-member", "POST", formData);
      if (res?.status) {
        const data = {
          emailId: formData?.emailId,
          password: formData?.password,
        };
        const loginRes = await HttpClient.requestData("login", "POST", data);
        setShowLoader(false);
        if (loginRes && loginRes.status) {
          reactLocalStorage.set("userDataNeoCard", loginRes?.data?.token);
          reactLocalStorage.set(
            "userDataNeoCardMemberStatus",
            JSON.stringify({ MemberStatus: loginRes?.data?.memberStatus })
          );
          navigate("/profile/" + loginRes?.data?.userName?.trim())
        }
      }
    } catch (error) {
      setShowLoader(false);
      console.log("Non member create:", error);
    }
  }

  return (
    <>
      <section className="Searchloginformmain">
        <div className="cust_container">
          <div className="Searchloginformmainbg">
            <div className="Searchloginformmainleft">
              <div className="Searchloginformmainleftimg">
                <img src={bannerloginimage} alt="banner" />
              </div>
            </div>

            <div className="Searchloginformmainright">
              {showLoader ? (<SkeletonSignupForm />) : (
                <div className="Searchloginformmainrightbg">
                  <h2 className="_creattusettxpp mb-4">Create your profile name for business or personal</h2>
                  <p>Share a link and connect customers to grow your audience with a free digital business card.</p>
                  <div className="mt-4">
                    <p className="usenametxttpp">Profile name</p>
                    <input
                      type="text"
                      placeholder="Enter desired profile name"
                      className="neooTextbox"
                      name="userName"
                      value={userName}
                      onChange={(e) => {
                        const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9_]/g, '');
                        setUserName(cleanedValue);
                        checkProfileName(cleanedValue)
                      }}
                    />
                    <p className="p-1">{`${process.env.REACT_APP_APPLICATION_URL}/profile/${userName}`}</p>
                  </div>
                  {userName && (
                    <p className="error-message">
                      {formError.userNameError ? "Not available ❌" : "Available ✅"}
                    </p>
                  )}

                  <button className="btnnexttdivbtn mt-5"
                    disabled={formError.userNameError}
                    onClick={(e) => handleCreate(e)}
                  >
                    Create
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CardMemberRegistrationProfileName;
